<button
  mat-button
  [matMenuTriggerFor]="menu"
  [disabled]="(itens || []).length < 2"
  >
  <mat-icon>switch_account</mat-icon>
  {{selecionada?.nome || textoEscolha}}
</button>
<mat-menu #menu="matMenu" class="menu-contas">
  <ui-search
    [placeHolder]="textoBusca"
    (submitEvent)="filtrar($event)"
    (click)="naoFecharMenu($event)"
  ></ui-search>
  @for (item of itensFiltrados$ | async; track item) {
    <button
      mat-menu-item
      role="menuitemcheckbox"
      (click)="selecionar(item)"
      >
      {{item.nome}}
    </button>
  }
</mat-menu>